/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsUnderUtilizedOciAdvisorResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsUnderUtilizedOciAdvisorResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsUnderUtilizedOciAdvisorResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsUnderUtilizedOciAdvisorResource>): RecommendationForFinopsUnderUtilizedOciAdvisorResource {
        let obj = Object.assign(new RecommendationForFinopsUnderUtilizedOciAdvisorResource(), model);
        RecommendationForFinopsUnderUtilizedOciAdvisorResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsUnderUtilizedOciAdvisorResource>): RecommendationForFinopsUnderUtilizedOciAdvisorResource {
        if (!model) return null;
        return RecommendationForFinopsUnderUtilizedOciAdvisorResource.newInstance(<RecommendationForFinopsUnderUtilizedOciAdvisorResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsUnderUtilizedOciAdvisorResource) {
        if (!obj) return;

        models.RecommendationForFinopsUnderUtilizedOciAdvisorResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsUnderUtilizedOciAdvisorResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsUnderUtilizedOciAdvisorResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
